import { render, staticRenderFns } from "./latest.vue?vue&type=template&id=139d8a68&scoped=true&"
import script from "./latest.vue?vue&type=script&lang=js&"
export * from "./latest.vue?vue&type=script&lang=js&"
import style0 from "./latest.vue?vue&type=style&index=0&id=139d8a68&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "139d8a68",
  null
  
)

export default component.exports